var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',{style:({ width: _vm.width }),attrs:{"id":_vm.chartID}})])}
var staticRenderFns = []

export { render, staticRenderFns }